/**
 *  @class
 *  @function SlideShow
 */
if (!customElements.get('slide-show')) {
  class SlideShow extends HTMLElement {
    constructor() {
      super();
      const slideshow = this,
        dataset = slideshow.dataset;

      let dots = dataset.dots === 'true',
        slideshow_slides = Array.from(slideshow.querySelectorAll('.carousel__slide')),
        autoplay = dataset.autoplay == 'false' ? false : parseInt(dataset.autoplay, 10),
        align = dataset.align == 'center' ? 'center' : 'left',
        fade = dataset.fade == 'true' ? true : false,
        draggable = dataset.draggable == 'false' ? false : true,
        prev_button = slideshow.querySelector('.flickity-prev'),
        next_button = slideshow.querySelector('.flickity-next'),
        custom_dots = slideshow.querySelector('.flickity-page-dots'),
        progress_bar = slideshow.parentNode.querySelector('.flickity-progress--bar'),
        animations = [],
        rightToLeft = document.dir === 'rtl',
        animations_enabled = document.body.classList.contains('animations-true') && typeof gsap !== 'undefined';

      if (slideshow_slides.length < 1) return;
      const args = {
        wrapAround: true,
        cellAlign: align,
        pageDots: false,
        contain: true,
        fade: fade,
        draggable: draggable,
        autoPlay: autoplay,
        rightToLeft: rightToLeft,
        prevNextButtons: false,
        cellSelector: '.carousel__slide',
        on: {}
      };


      if (slideshow.classList.contains('yc-slideshow2__slider')) {
        args.draggable = false;
      }
      
      if (slideshow.classList.contains('image-with-text-slideshow__image')) {
        let main_slideshow = slideshow.parentNode.querySelector('.image-with-text-slideshow__content'),
          image_slideshow_slides = slideshow.querySelectorAll('.image-with-text-slideshow__image-media');
        args.draggable = false;
        args.asNavFor = main_slideshow;

        if (image_slideshow_slides.length) {
          if (image_slideshow_slides[0].classList.contains('desktop-height-auto')) {
            args.adaptiveHeight = true;
          }
        }
      }
      if (slideshow.classList.contains('customer-reviews__image')) {
        let main_slideshow = slideshow.parentNode.querySelector('.customer-reviews__content');
        args.draggable = false;
        args.asNavFor = main_slideshow;
      }
      if (slideshow.classList.contains('image-with-text-slideshow__content') ||
        slideshow.classList.contains('testimonials__carousel') ||
        slideshow.classList.contains('customer-reviews__content') ||
        slideshow.classList.contains('customer-reviews__image')) {
        args.adaptiveHeight = true;
      }
      if (slideshow.classList.contains('custom-dots')) {

        if (animations_enabled && slideshow.classList.contains('main-slideshow')) {
          this.prepareAnimations(slideshow, animations);
        }
        args.pauseAutoPlayOnHover = false;

        args.on = {
          staticClick: function () {
            this.unpausePlayer();
          },
          ready: function () {
            let flkty = this;
            // Animations.
            if (animations_enabled && slideshow.classList.contains('main-slideshow')) {
              slideshow.animateSlides(0, animations);
              gsap.set(slideshow.querySelectorAll('.subheading,.split-text,.button'), { visibility: 'visible' });
            }

            // Custom Dots.
            if (dots && custom_dots) {
              let dots = custom_dots.querySelectorAll('li');
              dots.forEach((dot, i) => {
                dot.addEventListener('click', (e) => {
                  flkty.select(i);
                });
              });
              dots[this.selectedIndex].classList.add('is-selected');
            }
            document.fonts.ready.then(function () {
              flkty.resize();
            });

            // Video Support.
            let video_container = flkty.cells[0].element.querySelector('.slideshow__slide-video-bg');
            if (video_container) {
              if (video_container.querySelector('iframe')) {
                video_container.querySelector('iframe').onload = function () {
                  slideshow.videoPlay(video_container);
                };
              } else if (video_container.querySelector('video')) {
                video_container.querySelector('video').onloadstart = function () {
                  slideshow.videoPlay(video_container);
                };
              }
            }
          },
          change: function (index) {
            flkty.cells[0].element.classList.remove('is-initial-selected');
            let previousIndex = fizzyUIUtils.modulo(this.selectedIndex - 1, this.slides.length),
              nextIndex = fizzyUIUtils.modulo(this.selectedIndex + 1, this.slides.length);

            // Animations.
            if (animations_enabled && slideshow.classList.contains('main-slideshow')) {
              setTimeout(() => {
                slideshow.animateReverse(previousIndex, animations);
              }, 300);
              slideshow.animateSlides(index, animations);
            }

            // Custom Dots.
            if (dots && custom_dots) {
              let dots = custom_dots.querySelectorAll('li');
              dots.forEach((dot, i) => {
                dot.classList.remove('is-selected');
              });
              dots[this.selectedIndex].classList.add('is-selected');
            }

            // AutoPlay
            if (autoplay) {
              this.stopPlayer();
              this.playPlayer();
            }

            // Video Support.
            // previous slide
            let video_container_prev = flkty.cells[previousIndex].element.querySelector('.slideshow__slide-video-bg');
            if (video_container_prev) {
              slideshow.videoPause(video_container_prev);
            }
            // next slide
            let video_container_next = flkty.cells[nextIndex].element.querySelector('.slideshow__slide-video-bg');
            if (video_container_next) {
              slideshow.videoPause(video_container_next);
            }
            // current slide
            let video_container = flkty.cells[index].element.querySelector('.slideshow__slide-video-bg');
            if (video_container) {
              if (video_container.querySelector('iframe')) {
                if (video_container.querySelector('iframe').classList.contains('lazyload')) {
                  video_container.querySelector('iframe').addEventListener('lazybeforeunveil', slideshow.videoPlay(video_container));
                  lazySizes.loader.checkElems();
                } else {
                  slideshow.videoPlay(video_container);
                }
              } else if (video_container.querySelector('video')) {
                slideshow.videoPlay(video_container);
              }
            }

          }
        };
      }
      if (slideshow.classList.contains('shoppable-video-reels--carousel')) {
        args.on.staticClick = function (event, pointer, cellElement, cellIndex) {
          if (typeof cellIndex == 'number') {
            flkty.select(cellIndex);
          }
        };
      }
      if (slideshow.classList.contains('main-slideshow')) {
        if (slideshow.classList.contains('desktop-height-image') || slideshow.classList.contains('mobile-height-image')) {
          args.adaptiveHeight = true;
        }
      }
      if (slideshow.classList.contains('products')) {
        args.wrapAround = false;
        args.on.ready = function () {
          var flickity = this;
          if (next_button) {
            window.addEventListener('resize', function () {
              slideshow.centerArrows(flickity, prev_button, next_button);
            });
          }
          window.dispatchEvent(new Event('resize'));
        };
      }
      if (progress_bar) {
        args.wrapAround = false;
        args.on.scroll = function (progress) {
          progress = Math.max(0, Math.min(1, progress));

          progress_bar.style.width = progress * 100 + '%';

        };
      }
      const flkty = new Flickity(slideshow, args);
      this.setupContentTriggers(slideshow, flkty);
      this.setupSizeSync(slideshow, flkty);

      slideshow.dataset.initiated = true;


      if (prev_button) {
        prev_button.addEventListener('click', (event) => {
          flkty.previous();
        });
        prev_button.addEventListener('keyup', (event) => {
          flkty.previous();
        });
        next_button.addEventListener('click', (event) => {
          flkty.next();
        });
        next_button.addEventListener('keyup', (event) => {
          flkty.next();
        });
      }
      if (Shopify.designMode) {
        slideshow.addEventListener('shopify:block:select', (event) => {
          let index = slideshow_slides.indexOf(event.target);
          flkty.select(index);
        });
      }

    }
    disconnectedCallback() {
      if (typeof this.cleanupContentTriggers === 'function') {
        this.cleanupContentTriggers();
        this.cleanupContentTriggers = null;
      }
      if (typeof this.cleanupSizeSync === 'function') {
        this.cleanupSizeSync();
        this.cleanupSizeSync = null;
      }
    }
    setupContentTriggers(slideshow, flkty) {
      const triggers = Array.from(slideshow.querySelectorAll('[data-slideshow-content-trigger]'));
      if (!triggers.length) {
        return;
      }

      const listeners = [];
      const closePanel = (trigger) => {
        const panel = document.getElementById(trigger.getAttribute('aria-controls'));
        const slide = trigger.closest('.slideshow__slide');
        trigger.setAttribute('aria-expanded', 'false');
        if (slide) {
          slide.classList.remove('slideshow__slide--panel-open');
        }
        if (panel) {
          panel.classList.remove('is-active');
          panel.setAttribute('aria-hidden', 'true');
        }
      };
      const openPanel = (trigger) => {
        const panel = document.getElementById(trigger.getAttribute('aria-controls'));
        const slide = trigger.closest('.slideshow__slide');
        trigger.setAttribute('aria-expanded', 'true');
        if (slide) {
          slide.classList.add('slideshow__slide--panel-open');
        }
        if (panel) {
          panel.classList.add('is-active');
          panel.setAttribute('aria-hidden', 'false');
        }
      };
      const closeAllPanels = (exceptTrigger) => {
        triggers.forEach((trigger) => {
          if (trigger !== exceptTrigger) {
            closePanel(trigger);
          }
        });
      };
      const stopCarouselInteraction = (event) => {
        event.stopPropagation();
      };

      triggers.forEach((trigger) => {
        const panel = document.getElementById(trigger.getAttribute('aria-controls'));
        const handleClick = (event) => {
          event.preventDefault();
          event.stopPropagation();

          const isExpanded = trigger.getAttribute('aria-expanded') === 'true';
          closeAllPanels(trigger);

          if (isExpanded) {
            closePanel(trigger);
          } else {
            openPanel(trigger);
            if (flkty && typeof flkty.pausePlayer === 'function') {
              flkty.pausePlayer();
            }
          }
        };

        trigger.addEventListener('click', handleClick);
        trigger.addEventListener('pointerdown', stopCarouselInteraction);
        listeners.push({ element: trigger, eventName: 'click', handler: handleClick });
        listeners.push({ element: trigger, eventName: 'pointerdown', handler: stopCarouselInteraction });

        if (panel) {
          panel.addEventListener('click', stopCarouselInteraction);
          panel.addEventListener('pointerdown', stopCarouselInteraction);
          listeners.push({ element: panel, eventName: 'click', handler: stopCarouselInteraction });
          listeners.push({ element: panel, eventName: 'pointerdown', handler: stopCarouselInteraction });
        }
      });

      const handleDocumentClick = (event) => {
        if (!slideshow.contains(event.target)) {
          closeAllPanels();
        }
      };
      const handleKeyup = (event) => {
        if (event.key === 'Escape') {
          closeAllPanels();
        }
      };
      const handleSlideChange = () => closeAllPanels();

      document.addEventListener('click', handleDocumentClick);
      document.addEventListener('keyup', handleKeyup);
      if (flkty && typeof flkty.on === 'function') {
        flkty.on('change', handleSlideChange);
      }

      this.cleanupContentTriggers = () => {
        listeners.forEach(({ element, eventName, handler }) => {
          element.removeEventListener(eventName, handler);
        });
        document.removeEventListener('click', handleDocumentClick);
        document.removeEventListener('keyup', handleKeyup);
        if (flkty && typeof flkty.off === 'function') {
          flkty.off('change', handleSlideChange);
        }
      };
    }
    setupSizeSync(slideshow, flkty) {
      let resizeFrame = null;
      let lastObservedWidth = Math.round(slideshow.getBoundingClientRect().width);
      const mediaElements = Array.from(slideshow.querySelectorAll('img, video, iframe'));
      const syncSize = () => {
        if (!slideshow.isConnected) {
          return;
        }
        if (resizeFrame) {
          cancelAnimationFrame(resizeFrame);
        }
        resizeFrame = requestAnimationFrame(() => {
          flkty.resize();
          if (flkty.options.adaptiveHeight && typeof flkty.setGallerySize === 'function') {
            flkty.setGallerySize();
          }
        });
      };
      const handleResize = () => {
        lastObservedWidth = Math.round(slideshow.getBoundingClientRect().width);
        syncSize();
      };
      const handleLazyLoaded = (event) => {
        if (slideshow.contains(event.target)) {
          syncSize();
        }
      };
      const mediaLoadHandlers = mediaElements.map((mediaElement) => {
        let eventNames = ['load'];
        if (mediaElement.tagName === 'VIDEO') {
          eventNames = ['loadeddata', 'loadedmetadata'];
        }
        eventNames.forEach((eventName) => {
          mediaElement.addEventListener(eventName, syncSize);
        });
        return {
          mediaElement,
          eventNames
        };
      });
      let sizeObserver = null;
      if (typeof ResizeObserver !== 'undefined') {
        sizeObserver = new ResizeObserver((entries) => {
          const widthChanged = entries.some((entry) => {
            const nextWidth = Math.round(entry.contentRect.width);
            if (nextWidth !== lastObservedWidth) {
              lastObservedWidth = nextWidth;
              return true;
            }
            return false;
          });
          if (widthChanged) {
            syncSize();
          }
        });
        [slideshow, slideshow.parentElement].filter(Boolean).forEach((element) => {
          sizeObserver.observe(element);
        });
      }

      window.addEventListener('resize', handleResize);
      window.addEventListener('orientationchange', syncSize);
      document.addEventListener('lazyloaded', handleLazyLoaded);
      document.fonts.ready.then(syncSize);
      setTimeout(syncSize, 100);

      this.cleanupSizeSync = () => {
        if (resizeFrame) {
          cancelAnimationFrame(resizeFrame);
        }
        if (sizeObserver) {
          sizeObserver.disconnect();
        }
        window.removeEventListener('resize', handleResize);
        window.removeEventListener('orientationchange', syncSize);
        document.removeEventListener('lazyloaded', handleLazyLoaded);
        mediaLoadHandlers.forEach(({ mediaElement, eventNames }) => {
          eventNames.forEach((eventName) => {
            mediaElement.removeEventListener(eventName, syncSize);
          });
        });
      };
    }
    videoPause(video_container) {
      setTimeout(() => {
        if (video_container.dataset.provider === 'hosted') {
          video_container.querySelector('video').pause();
        } else if (video_container.dataset.provider === 'youtube') {
          video_container.querySelector('iframe').contentWindow.postMessage(JSON.stringify({
            event: "command",
            func: "pauseVideo",
            args: ""
          }), "*");
        } else if (video_container.dataset.provider === 'vimeo') {
          video_container.querySelector('iframe').contentWindow.postMessage(JSON.stringify({
            method: "pause"
          }), "*");
        }
      }, 10);
    }
    videoPlay(video_container) {
      setTimeout(() => {
        if (video_container.dataset.provider === 'hosted') {
          video_container.querySelector('video').play();
        } else if (video_container.dataset.provider === 'youtube') {
          video_container.querySelector('iframe').contentWindow.postMessage(JSON.stringify({
            event: "command",
            func: "playVideo",
            args: ""
          }), "*");
        } else if (video_container.dataset.provider === 'vimeo') {
          video_container.querySelector('iframe').contentWindow.postMessage(JSON.stringify({
            method: "play"
          }), "*");
        }
      }, 10);
    }
    prepareAnimations(slideshow, animations) {
      if (!slideshow.dataset.animationsReady) {
        new SplitText(slideshow.querySelectorAll('.split-text'), {
          type: 'lines, words',
          linesClass: 'line-child'
        });
        slideshow.querySelectorAll('.slideshow__slide').forEach((item, i) => {
          let tl = gsap.timeline({
            paused: true
          }),
            button_offset = 0;

          animations[i] = tl;

          if (slideshow.dataset.transition == 'swipe') {
            tl
              .fromTo(item, {
                clipPath: 'polygon(0 0, 0 0, 0 100%, 0 100%)'
              }, {
                duration: 0.7,
                clipPath: "polygon(0 0, 100% 0, 100% 100%, 0 100%)"
              }, "start");
          }
          tl
            .to(item.querySelector('.slideshow__slide-bg'), {
              duration: 1.5,
              scale: 1
            }, "start");

          if (item.querySelector('.subheading')) {
            tl
              .to(item.querySelector('.subheading'), {
                duration: 0.5,
                autoAlpha: 1
              }, 0);

            button_offset += 0.5;
          }
          if (item.querySelector('.slideshow__slide-content--heading')) {
            let h1_duration = 0.5 + ((item.querySelectorAll('.slideshow__slide-content--heading .line-child div').length - 1) * 0.05);
            tl
              .from(item.querySelectorAll('.slideshow__slide-content--heading .line-child div'), {
                duration: h1_duration,
                yPercent: '100',
                stagger: 0.05
              }, 0);
            button_offset += h1_duration;
          }
          if (item.querySelector('p:not(.subheading)')) {

            let p_duration = 0.5 + ((item.querySelectorAll('p:not(.subheading) .line-child div').length - 1) * 0.02);
            tl
              .from(item.querySelectorAll('p:not(.subheading) .line-child div'), {
                duration: p_duration,
                yPercent: '100',
                stagger: 0.02
              }, 0);
            button_offset += p_duration;
          }
          if (item.querySelectorAll('.button')) {
            tl
              .fromTo(item.querySelectorAll('.button'), {
                y: '100%'
              }, {
                duration: 0.5,
                y: '0%',
                stagger: 0.1,
              }, button_offset * 0.2);
          }
          item.dataset.timeline = tl;
        });
        slideshow.dataset.animationsReady = true;
      }
    }
    animateSlides(i, animations) {
      document.fonts.ready.then(function () {
        animations[i].timeScale(1).restart();
      });
    }
    animateReverse(i, animations) {
      animations[i].timeScale(3).reverse();
    }
    centerArrows(flickity, prev_button, next_button) {
      let first_cell = flickity.cells[0],
        max_height = 0,

        image_height = first_cell.element.querySelector('.product-featured-image').clientHeight;

      flickity.cells.forEach((item, i) => {
        if (item.size.height > max_height) {
          max_height = item.size.height;
        }
      });


      if (max_height > image_height) {
        let difference = (max_height - image_height) / -2;

        prev_button.style.transform = 'translateY(' + difference + 'px)';
        next_button.style.transform = 'translateY(' + difference + 'px)';
      }
    }
  }
  customElements.define('slide-show', SlideShow);
}
